import React from 'react'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import BackButton from './styled'

const WalstoreBackButton = ({ history }) => (
  <div>
    <BackButton id="backButton" onClick={history.goBack} type="button">
      <img src="/catalogo/images/btn-atr-s.svg" alt="" />
    </BackButton>
  </div>
)

export default withRouter(WalstoreBackButton)

WalstoreBackButton.defaultProps = {
  history: {},
}

WalstoreBackButton.propTypes = {
  history: PropTypes.object,
}
